import { useContext } from 'react';

import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';

import { ModalContext } from 'src/context/Modal/ModalContext';

import { ComponentProps } from 'src/lib/ComponentProps';

import { Modal } from 'src/components/basicContent/_Modal/Modal';

type ContentOverviewModalsProps = ComponentProps;

export default function ContentOverviewModals(props: ContentOverviewModalsProps): JSX.Element {
	const ModalState = useContext(ModalContext);

	return (
		<>
			{/* Enrol Modal */}
			<Modal
				modalState={ModalState.modalInfo?.CourseEnrolModal?.Display ?? false}
				setModalState={ModalState.updateDisplayCourseEnrolModal}
				afterClose={() => ModalState.updateDisplayCourseEnrolModal(false)}
			>
				<Placeholder name="rcnlearn-courseenrolmodal" rendering={props.rendering} />
			</Modal>

			{/* Register Interest Modal */}
			<Modal
				modalState={ModalState.modalInfo?.CourseRegisterInterestModal?.Display ?? false}
				setModalState={ModalState.updateDisplayCourseRegisterInterestModal}
				afterClose={() => ModalState.updateDisplayCourseRegisterInterestModal(false)}
			>
				<Placeholder name="rcnlearn-courseregistermodal" rendering={props.rendering} />
			</Modal>
		</>
	);
}
